export default "__VITE_ASSET__bd15ba0a__"